/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Loader from '../../newLoader/Loader'
import Image from 'next/legacy/image'
import { GET_VETERINARIANS } from '../../../graphql'
import useMediaQuery from '../../../utils/publicApi'
import query from '../../../utils/query'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from './featureVets.module.scss'

const Card = ({ data, isMobile }) => {
  const {
    name,
    rating,
    review_count: reviews,
    image_url: src,
    url,
    is_closed: isClosed,
    phone,
    location,
  } = data
  const { zip_code: zipCode, address1, city, state } = location
  const locations = `${zipCode} ${address1}, ${city}, ${state}`

  const stars = (numberRate) => {
    const ratingArr = [1, 1, 1, 1, 1].fill(0, numberRate)

    if (!Number.isInteger(Number(numberRate))) {
      const isCero = (element) => element < 1
      const index = ratingArr.findIndex(isCero)
      return (
        <>
          {ratingArr.map((rating, i) =>
            i === index ? (
              <img
                key={i}
                alt="half star icon"
                style={{ width: '19px ', marginTop: '3px' }}
                src="/vets/vets-data/star-half.svg"
              />
            ) : rating ? (
              <img
                key={i}
                alt="yellow star icon"
                src="/vets/vets-data/star-yellow.svg"
              />
            ) : (
              <img
                key={i}
                alt="gray star icon"
                src="/vets/vets-data/star-gray.svg"
              />
            ),
          )}
        </>
      )
    } else {
      return (
        <>
          {ratingArr.map((rating, i) =>
            rating ? (
              <img
                key={i}
                alt="yellow star icon"
                src="/vets/vets-data/star-yellow.svg"
              />
            ) : (
              <img
                key={i}
                alt="gray star icon"
                src="/vets/vets-data/star-gray.svg"
              />
            ),
          )}
        </>
      )
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <div className={styles.imgDesktop}>
          <Image
            src={src.length > 0 ? src : '/vets/placeholder-vets.svg'}
            alt=""
            quality={75}
            layout="responsive"
            width={70}
            height={60}
            objectFit="cover"
            priority
          />
        </div>
        <div className={styles.imgMobile}>
          <Image
            src={src.length > 0 ? src : '/vets/placeholder-vets.svg'}
            alt=""
            quality={75}
            layout="responsive"
            width={50}
            height={20}
            objectFit="cover"
            priority
          />
        </div>
      </div>
      <div className={styles.data}>
        <div className={styles.name}>
          {isMobile && name.length > 25 ? name.slice(0, 25) + '...' : name}
        </div>
        <div className={styles.details}>
          <div className={styles.range}>{stars(rating)}</div>
          <span>
            {parseFloat(rating)} | {reviews} reviews
          </span>
          {isClosed ? (
            <div className={styles.isClosed}>Closed</div>
          ) : (
            <div className={styles.isOpen}>Open</div>
          )}
        </div>
        <div className={styles.buttons}>
          <a
            className={styles.content}
            href={`tel:${phone}`}
            onClick={() => {
              // GTM call
              if (window.dataLayer) {
                window.dataLayer.push({ event: 'call' })
              }
              // UA call
              if (window.ga?.getAll) {
                window.ga.getAll()[0].send('event', 'call')
              }
            }}
          >
            <img
              src="/vets/vets-data/phone.svg"
              alt="phone icon"
              className={styles.icon}
            />
            <div>{phone}</div>
          </a>
          <div className={styles.content}>
            <img src="/vets/vets-data/map-pin.svg" alt="map pin" />
            <div>
              {isMobile
                ? locations.length > 25
                  ? locations.slice(0, 25) + '...'
                  : locations
                : locations}
            </div>
          </div>
          <a className={styles.moreDetail} href={url}>
            More details
          </a>
        </div>
      </div>
    </div>
  )
}

function FeatureVets({ state, slug }) {
  const isMobile = useMediaQuery('(max-width:600px)')
  const location = slug
  const [vetsData, setVetsData] = useState([])
  const [loading, setLoading] = useState()

  const fetchVets = async () => {
    setLoading(true)
    const { getVeterinarians } = await query({
      query: GET_VETERINARIANS,
      variables: {
        location,
      },
    })

    setVetsData(getVeterinarians)
    setLoading(false)
  }

  useEffect(() => {
    fetchVets()
  }, [])

  const vetsStateData = vetsData
    ?.filter((el) => el.location.state === (slug || state))
    .slice(0, 10)

  return (
    <div className={styles.main}>
      {vetsStateData?.length > 0 ? (
        <h3 className={styles.title}>{`Best Rated Vets in ${state}`}</h3>
      ) : null}
      {loading ? (
        <div className={styles.loader}>
          <Loader theme="tall" />
        </div>
      ) : (
        <section className={styles.card}>
          <Swiper
            speed={1000}
            spaceBetween={10}
            initialSlide={0}
            grabCursor
            slidesPerView={isMobile ? 1.2 : 1.5}
          >
            {vetsStateData &&
              vetsStateData.map((data, index) => {
                return (
                  <SwiperSlide key={index}>
                    <Card data={data} isMobile={isMobile} />
                  </SwiperSlide>
                )
              })}
          </Swiper>
        </section>
      )}
    </div>
  )
}

export default FeatureVets
